import React, { useState } from "react";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";

const getFileType = (fileUrl) => {
  if (!fileUrl || typeof fileUrl !== "string") return "";
  const parts = fileUrl.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};
const isImageFile = (url) => ["jpg", "jpeg", "png"].includes(getFileType(url));
const isVideoFile = (url) => ["mp4", "mov"].includes(getFileType(url));
const isPdfFile = (url) => getFileType(url) === "pdf";
const getFileIcon = (url) =>
  iconData?.find((i) => i.extension === getFileType(url))?.icon ||
  "/images/file_icon.png";
const truncate = (text, max = 15) =>
  text?.length > max ? text.slice(0, max) + "..." : text;

export default function CheckBoxType({
  questionNo,
  response,
  type,
  question,
  setQuestionsAnswer,
}) {
  const [isClicked, setIsClicked] = useState(false);
  const [responseData, setRresponseData] = useState(response);
  const [responseAttach, setResponseAttach] = useState(null);
  const [isError, setIsError] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);

  const handleCheckboxChange = (e) => {
    setQuestionsAnswer((prev) => {
      let updatedData = prev.map((item) => {
        if (item.id === response?.id) {
          let explanation = "";
          item.question.options.forEach((option) => {
            if (option.key == e.target.value) explanation = option.value;
          });
          return {
            ...item,
            answer: {
              ...item.answer,
              key: e.target.value,
              explanation: explanation,
            },
          };
        }
        return item;
      });
      return updatedData;
    });

    setRresponseData((prev) => ({
      ...prev,
      answer: { ...prev.answer, key: e.target.value },
    }));
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked((v) => !v);
  };

  const handleClickforpdf = (fileUrl) => {
    setTimeout(() => {
      setResponseAttach(fileUrl);
      setMideaviewer(true);
    }, 100);
  };

  return (
    <>
      {response && (
        <div className="containerBelowQuestion">
          {/* ===== Question Title ===== */}
          <div className="flex justify-between">
            <div className="text-[15px] font-semibold text-slate-800 leading-relaxed">
              Q{questionNo}.{" "}
              {response?.question?.title?.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {index !== 0 && <br />}
                  <span
                    style={
                      index !== 0
                        ? { marginLeft: "30px", display: "inline-block" }
                        : {}
                    }
                  >
                    {line}
                  </span>
                </React.Fragment>
              ))}
              {response?.question?.is_mandatory && (
                <span className="ml-3 inline-block px-2 py-0.5 rounded bg-red-50 text-red-700 text-[10px] font-bold uppercase tracking-wide">
                  * Mandatory
                </span>
              )}
            </div>
          </div>

          {/* ===== Question Attachments ===== */}
          {response?.question?.attachments?.length > 0 &&
            response.question.attachments.map((attachment, index) => {
              const fileName = attachment?.replace(/^[^_]*_/, "") || "";
              const shortName =
                fileName.length > 15
                  ? fileName.substring(0, 15) + "..."
                  : fileName;
              const fullUrl = IP + attachment?.replace(/^\./, "");

              return (
                <div key={index} className="mt-2">
                  {isImageFile(attachment) ? (
                    <img
                      src={fullUrl}
                      alt="Attachment"
                      className="mt-3 imageWidthAndHeight cursor-pointer rounded-lg border border-slate-200 hover:shadow-md transition-shadow"
                      onClick={() => {
                        if (!isError) handleClick(attachment);
                      }}
                    />
                  ) : (
                    <div
                      onClick={() => handleClickforpdf(attachment)}
                      className="inline-flex items-center gap-2.5 px-3 py-2 rounded-lg border border-slate-200 bg-slate-50 hover:bg-slate-100 hover:border-slate-300 cursor-pointer transition-all max-w-xs"
                    >
                      <img
                        className="w-6 h-6 flex-shrink-0"
                        src={getFileIcon(attachment)}
                        alt="file"
                      />
                      <div className="min-w-0">
                        <div
                          className="text-xs font-semibold text-slate-700 truncate"
                          title={fileName}
                        >
                          {shortName}
                        </div>
                        <div className="text-[10px] text-slate-400">
                          Attachment
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

          {/* ===== Options ===== */}
          <div className="mt-5 space-y-2.5">
            {response?.question?.options?.length > 0 &&
              response?.question?.options?.map((option, index) => {
                const isSelected = option?.key === response?.answer?.key;
                const isManual = type !== "SA";
                return (
                  <React.Fragment key={option?.key ?? index}>
                    <div
                      onClick={() => {
                        if (!isManual) {
                          handleCheckboxChange({
                            target: { value: option?.key },
                          });
                        }
                      }}
                      className={[
                        "flex items-center justify-between gap-3 px-4 py-3 rounded-lg border-[1.5px] transition-all",
                        isSelected
                          ? "border-emerald-400 bg-emerald-50/50"
                          : "border-slate-200 bg-white",
                        !isManual
                          ? "cursor-pointer hover:border-orange-300 hover:bg-orange-50/30"
                          : "",
                      ].join(" ")}
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        {/* Custom checkbox */}
                        <div
                          className={[
                            "w-5 h-5 rounded flex items-center justify-center flex-shrink-0 border-2 transition-all",
                            isSelected
                              ? "bg-emerald-500 border-emerald-500"
                              : "bg-white border-slate-300",
                          ].join(" ")}
                        >
                          {isSelected && (
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M5 13L9 17L19 7"
                                stroke="#fff"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                        <input
                          type="checkbox"
                          className="sr-only"
                          name={`question_${response?.question?.id}`}
                          value={option?.key}
                          checked={isSelected}
                          onChange={handleCheckboxChange}
                          readOnly={isManual}
                        />
                        <span
                          className={[
                            "text-sm break-words",
                            isSelected
                              ? "text-slate-800 font-medium"
                              : "text-slate-600",
                          ].join(" ")}
                        >
                          {option?.value}
                        </span>
                      </div>

                      {isSelected && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap">
                          Your answer
                        </span>
                      )}
                    </div>

                    {/* Option attachment */}
                    {option?.attachment && (
                      <div className="ml-11 mt-1.5">
                        {renderOptionAttachment(
                          option.attachment,
                          handleClickforpdf,
                        )}
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      )}

      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {isClicked && responseAttach && (
        <FullSizeMediaModal
          responseAttach={responseAttach}
          isError={isError}
          setIsError={setIsError}
          onClose={handleClick}
        />
      )}
    </>
  );
}

// ===== Reusable option attachment renderer =====
function renderOptionAttachment(attachment, onPdfClick) {
  const fileUrl = typeof attachment === "string" ? attachment : attachment?.url;
  if (!fileUrl) return null;
  const fullUrl = fileUrl.startsWith("http") ? fileUrl : `${IP}${fileUrl}`;

  if (isImageFile(fileUrl)) return <ZoomableImage src={attachment} />;

  if (isVideoFile(fileUrl)) {
    return (
      <video
        src={fullUrl}
        style={{
          width: "60px",
          height: "50px",
          borderRadius: "6px",
          marginBottom: "5px",
        }}
        controls
      />
    );
  }

  if (isPdfFile(fileUrl)) {
    return (
      <div
        onClick={() => onPdfClick(fileUrl)}
        className="inline-flex items-center gap-2 px-2.5 py-2 rounded-md bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:border-slate-300 cursor-pointer transition-all"
      >
        <img src={getFileIcon(fileUrl)} alt="pdf" className="w-6 h-6" />
        <span className="text-xs font-medium text-slate-600 truncate">
          {truncate(fileUrl.replace(/^[^_]*_/, ""), 15)}
        </span>
      </div>
    );
  }

  return (
    <a
      href={`https://docs.google.com/gview?url=${encodeURIComponent(
        fullUrl,
      )}&embedded=true`}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 px-2.5 py-2 rounded-md bg-slate-50 border border-slate-200 hover:bg-slate-100 hover:border-slate-300 transition-all"
    >
      <img src={getFileIcon(fileUrl)} alt="file" className="w-6 h-6" />
    </a>
  );
}

// ===== Full-size media modal =====
function FullSizeMediaModal({ responseAttach, isError, setIsError, onClose }) {
  if (!responseAttach) return null;
  const ext = responseAttach.split(".").pop()?.toLowerCase();

  if (ext === "mp4") {
    return (
      <div className="fullSizeImg">
        <div className="SubfullSizeImg">
          <video className="videoPlayer" controls>
            <source
              src={IP + responseAttach.replace(/^\./, "")}
              type="video/mp4"
            />
          </video>
          <div>
            <img
              className="crossIconImgQue cursor-pointer"
              onClick={onClose}
              src="/DCM-img/crossIcon.svg"
              alt="Close"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fullSizeImg">
      <div className="SubfullSizeImg">
        {!isError ? (
          <>
            <img
              className="imgMain"
              src={IP + responseAttach.replace(/^\./, "")}
              alt="Full-size"
              onError={() => setIsError(true)}
            />
            <div>
              <img
                className="crossIconImgQue cursor-pointer"
                onClick={onClose}
                src="/images/cross.png"
                alt="Close"
              />
            </div>
          </>
        ) : (
          <div className="fullSizeImg flex flex-col items-center justify-center">
            <img
              onClick={() => {
                setIsError(false);
                onClose();
              }}
              src="/images/cross.png"
              alt="Close"
              className="cursor-pointer absolute top-[75px] right-[40%]"
            />
            <img src="/images/no-photo1.png" alt="img" className="w-1/4" />
            <p className="text-red-500 text-xl font-medium mt-4">
              Error!! failed to load the requested file!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
